import React from "react";
import "../styles/components/AboutSectionCenter.css";

const AboutSectionCenter = () => {
  return (
    <section className="about-center">
      <div className="container">
        <div className="about-content">
          <h2>O Centru</h2>
          <p>
            Psihološki Centar Clarity, koji vodi iskusni psiholog u Novom Sadu, osnovan je sa ciljem poboljšanja kvaliteta života pojedinaca i unapredjenja poslovanja različitih organizacija. Sa pažnjom i posvećenošću pružamo podršku ljudima i kompanijama na putu ka ličnom i profesionalnom razvoju.
          </p>
          <p>
            Centar poseduje dozvolu za rad nadležnog Ministarstva za rad, zapošljavanje, boračka i socijalna pitanja ( br. 002088159 2025 ) čime je po zakonu ozvaničena i dozvoljena psihološka delatnost Centra za oblasti: psihološka dijagnostika, savetovanje i psihoterapija.
          </p>
        </div>
        <img 
          src="/images/home-2.webp" 
          alt="Psiholog Novi Sad - O Centru Clarity, psihološko savetovanje i psihoterapija"
          className="image-side"
          width="800"
          height="400"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default AboutSectionCenter;
